import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MiniPie } from '../MiniPie';
import { vpmobile } from '../../../utils';
import './SectorWeightBadge.scss';
export const SectorWeightBadge = ({ weight }) => {
    const percent = Math.round(weight * 1000) / 10;
    return (_jsxs("dl", { className: "sector-weight-badge", children: [_jsxs("dt", { children: [_jsx("span", { children: "Sektorens vekt" }), " ", _jsxs("span", { children: ["i ", vpmobile() ? `barometeret` : 'Kommunebarometeret'] })] }), _jsx("dd", { children: _jsxs("div", { className: "sector-diagram", children: [_jsx(MiniPie, { value: weight }), _jsxs("span", { children: [percent, "%"] })] }) })] }));
};
